<main>
  <app-header></app-header>

  <app-navigation-admin></app-navigation-admin>

  <div class="container">
    <router-outlet></router-outlet>
  </div>
</main>
